import styled from "@emotion/styled";

export const RolePickerContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    width: 100%;
    max-width: 320px;
`;

export const RolePickerTitle = styled.h2`
    margin: 0;
    font-size: 1.4rem;
`;

export const RolePickerSubtitle = styled.p`
    margin: 0 0 0.5rem 0;
    font-size: 0.9rem;
    color: #444;
`;

export const RoleButton = styled.button`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
    width: 100%;
    padding: 0.75rem 1rem;
    border-radius: 0.375rem;
    border: 1px solid #d8c0c0;
    background-color: #ffffff;
    color: #000000;
    cursor: pointer;
    font-family: Helvetica, Arial, sans-serif;
    text-align: left;

    &:hover {
        background-color: rgb(22 59 93);
        color: #ffffff;
        border-color: rgb(22 59 93);
    }
`;

export const RoleName = styled.span`
    font-weight: 600;
    text-transform: capitalize;
`;

export const RoleEntity = styled.span`
    font-size: 0.8rem;
    opacity: 0.8;
`;
